import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

import type { SubmitButtonProps } from "./SubmitButtonProps";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubmitButton',
  props: {
    label: {},
    isSubmitting: { type: Boolean },
    backgroundColor: {},
    textColor: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "f0a11e0e": (_ctx.backgroundColor),
  "fe9bd94c": (_ctx.textColor)
}))



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "submit",
    class: "block w-full rounded-md px-3.5 py-2.5 text-center text-sm font-semibold",
    disabled: _ctx.isSubmitting
  }, _toDisplayString(_ctx.label), 9, _hoisted_1))
}
}

})